import moment from "moment";

export const getQuizLabel = (username: string, message: string): string => {
  return username !== "Declarante"
    ? `${username} ${message}`
    : `Você ${message}`;
};

export const isSafari = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent
);

export const isMobile = (): boolean => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

export const isExternalLink = (link: string): boolean => {
  return /http:\/\/|https:\/\//i.test(link);
};

export const errorMessage =
  "Algo inesperado aconteceu. Tente novamente mais tarde.";

export const reintegrateMessage =
  "Faça novamente a integração para buscar dados mais novos";

export const download = (link: string) => {
  const userAgentString = navigator.userAgent;
  let chromeAgent = userAgentString.indexOf("Chrome") > -1;
  let safariAgent = userAgentString.indexOf("Safari") > -1;
  if (chromeAgent && safariAgent) safariAgent = false;
  if (safariAgent) {
    window.location.href = link;
    return;
  } else {
    window.open(link);
  }
};

export const getBrowser = () => {
  var sBrowser,
    sUsrAg = navigator.userAgent;

  if (sUsrAg.indexOf("Firefox") > -1) {
    sBrowser = "Mozilla Firefox";
    // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
  } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
    sBrowser = "Samsung Internet";
    // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
  } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
    sBrowser = "Opera";
    // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
  } else if (sUsrAg.indexOf("Trident") > -1) {
    sBrowser = "Microsoft Internet Explorer";
    // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
  } else if (sUsrAg.indexOf("Edge") > -1) {
    sBrowser = "Microsoft Edge";
    // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
  } else if (sUsrAg.indexOf("Chrome") > -1) {
    sBrowser = "Google Chrome or Chromium";
    // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
  } else if (sUsrAg.indexOf("Safari") > -1) {
    sBrowser = "Apple Safari";
    // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
  } else {
    sBrowser = "unknown";
  }

  return sBrowser;
};

export const fator = (item: any) => {
  const value = (item.quantity || 0) * (item.sellPrice || 0);
  const code = item.code?.substring(0, 3)?.toUpperCase() || "";
  switch (code) {
    case "WIN":
      return value / 5;
    case "WDO":
      return value / 10;
    case "DOL":
      return value / 50;
    case "IAP":
      return value / 25;
    case "ETN":
      return value / 30;
    case "ETH":
      return value / 30;
    case "SOY":
      return value / 34;
    case "CNY":
      return value / 35;
    case "EUR":
      return value / 50;
    case "ICF":
      return value / 100;
    case "KFE":
      return value / 100;
    case "OZ1":
      return value / 250;
    case "CCM":
      return value / 450;
    case "SFI":
      return value / 450;
    case "SJC":
      return value / 450;
    case "ACF":
      return value / 508;
    default:
      return value;
  }
};

const exteriorTransactionsFilter = (el: any) =>
  (el.operation === "SELL" && !el?.type) ||
  (el.operation === "SELL" && el.manual) ||
  (el.operation === "SELL" &&
    (el.type === "TRADE" || el.type === "WITHDRAW")) ||
  el.type === "INTEREST";

export const vendasTotaisExt = (item: any) => {
  const filteredItems = item?.transactions?.filter(exteriorTransactionsFilter) ?? []
  return filteredItems?.reduce((a: number, t: any) => {
      if (t.varTotalBRL) {
        return a + (t.varTotalBRL || 0) * (t.quantity || 0);
      }
      return a + (t.valor || 0) * (t.cambioVenda || 0)
    }, 0) || 0;
}

export const vendasTotais = (item: any) =>
  item?.transactions?.reduce((a: number, t: any) => a + fator(t), 0) || 0;

export const downloadPDF = (base64: string, fileName?: string) => {
  const linkSource = `data:application/pdf;base64,${base64}`;
  const downloadLink = document.createElement("a");
  fileName = fileName ?? `Relatório-${Date.now()}.pdf`;

  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

export const mesesPassados = (date: Date) => {
  const hoje = new Date();
  const anoAtual = hoje.getFullYear();
  const mesAtual = hoje.getMonth();

  const anoSelecionado = date.getFullYear();

  const mesesPassados = [];

  if (anoSelecionado < anoAtual) {
    for (let i = 0; i < 12; i++) {
      mesesPassados.push(i + 1);
    }
  } else if (anoSelecionado === anoAtual) {
    for (let i = 0; i < mesAtual; i++) {
      mesesPassados.push(i + 1);
    }
  }

  return mesesPassados.sort((a, b) => b - a);
};

export const isAntesTerceiroDiaUtil = () => {
  const today = moment();
  // Verifica se a data de hoje é anterior ao dia 7 do mês
  const seventhDayOfMonth = moment(today).startOf('month').add(6, 'days'); // Dia 7 (índice 6)
  return today.isBefore(seventhDayOfMonth);
}

export const thirdBusinessDayAndMonth = (item: any) => {
  const today = new Date();
  const currentMonth = today.getMonth() + 1;
  const currentYear = today.getFullYear();
  if (item.year === currentYear && item.month === currentMonth)
    return { disabled: true, title: "Aguarde o encerramento do mês para pagar seu DARF" }
  else if (item.month == currentMonth - 1 && item.year == currentYear && isAntesTerceiroDiaUtil())
    return { disabled: true, title: "Aguarde o dia 7, para pagar seu DARF" }
  else return { disabled: false, title: "" }
}



export const isAlreadyFormatted = (dateString: string): boolean => {
  const formattedPatterns = [
    /última atualização/i,
    /atualizado em/i,
    /atualização em/i,
    /em \d{2}\/\d{2}\/\d{4}/i,
    /às \d{2}:\d{2}/i
  ];
  
  return formattedPatterns.some(pattern => pattern.test(dateString));
};

